import { render, staticRenderFns } from "./BoughtTogetherApp.vue?vue&type=template&id=65305a0b&"
import script from "./BoughtTogetherApp.vue?vue&type=script&lang=js&"
export * from "./BoughtTogetherApp.vue?vue&type=script&lang=js&"
import style0 from "./BoughtTogetherApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BoughtTogetherApp.vue"
export default component.exports